document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let swiperHighlights = new Swiper('.highlights__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 60,
        pagination: {
            el: '.highlights-pagination',
            clickable: true
        },
        navigation: {
            prevEl: `.highlights-prev`,
            nextEl: `.highlights-next`
        },
        breakpoints: {
            320: {
                slidesPerView: 1
            },
            1025: {
                slidesPerView: 3
            }
        }
    });

    let swiperReviews = new Swiper('.reviews__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 100,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: '.reviews-pagination',
            clickable: true
        },
        autoplay: {
            delay: 8000,
            disableOnInteraction: false
        },
        navigation: {
            prevEl: `.reviews-prev`,
            nextEl: `.reviews-next`
        },
    });

    let swiperReviewsSuites = new Swiper('.reviews-suites__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 100,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        uniqueNavElements: false,
        pagination: {
            el: '.reviews-suites-pagination',
            clickable: true
        },
        autoplay: {
            delay: 8000,
            disableOnInteraction: false
        }
        // navigation: {
        //     prevEl: `.reviews-prev`,
        //     nextEl: `.reviews-next`
        // },
    });

    let swiperReviewsHotels = new Swiper('.reviews-hotels__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 100,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        uniqueNavElements: false,
        pagination: {
            el: '.reviews-hotels-pagination',
            clickable: true
        },
        // autoplay: {
        //     delay: 8000,
        //     disableOnInteraction: false
        // },
        navigation: {
            prevEl: `.reviews-hotels-prev`,
            nextEl: `.reviews-hotels-next`
        },
    });

    let quadGallery = new Swiper('.gallery-quad__slider',{
        speed: 700,
        loop: true,
        centeredSlides: true,
        slidesPerView: 1.2,
        spaceBetween: 15,
        navigation: {
            prevEl: `.gallery-quad-prev`,
            nextEl: `.gallery-quad-next`
        },
        breakpoints: {
            760: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1025: {
                slidesPerView: 3,
                spaceBetween: 60,
            }
        }
    });

    let allOffersQuads = document.querySelectorAll('.offers-quad__slider');

    if(allOffersQuads.length > 0){
        allOffersQuads.forEach((offerQuad)=>{
            let dataId = offerQuad.dataset.id;
            let quadOffers = new Swiper(offerQuad,{
                speed: 700,
                loop: true,
                effect: 'fade',
                autoHeight: true,
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    prevEl: `.offers-quad-prev${dataId}`,
                    nextEl: `.offers-quad-next${dataId}`
                },
                breakpoints: {
                    600: {
                        autoHeight: false
                    }
                }
            })
        })
    }

    let quadSlider = new Swiper('.slider__slider',{
        speed: 700,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-prev',
            nextEl: '.slider-next'
        }
    });

    let quadSliderSuites = new Swiper('.slider-suites__slider',{
        speed: 700,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-suites-prev',
            nextEl: '.slider-suites-next'
        }
    });

    let quadSliderVenues = new Swiper('.slider-venues__slider',{
        speed: 700,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-venues-prev',
            nextEl: '.slider-venues-next'
        }
    });

    let quadAwards = new Swiper('.awards__slider',{
        speed: 700,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            prevEl: '.awards-prev',
            nextEl: '.awards-next'
        },
        breakpoints: {
            760: {
                slidesPerView: 2,
                spaceBetween: 60,
            },
            1025: {
                slidesPerView: 3,
                spaceBetween: 120,
            }
        }
    });

    let swiperTimeline = new Swiper('.timeline__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        uniqueNavElements: false,
        pagination: {
            el: '.timeline-pagination',
            clickable: true
        },
        navigation: {
            prevEl: '.timeline-prev',
            nextEl: '.timeline-next'
        }
    });

    if(document.querySelector('.slider-offers__slider')){
        let allSlidersOffers =  document.querySelectorAll('.slider-offers__slider');

        allSlidersOffers.forEach((sliderOffer, index)=>{
            let offerId = sliderOffer.dataset.id;
            let sliderOffers = new Swiper(sliderOffer,{
                loop: true,
                speed: 700,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    prevEl: `.slider-offers-prev${offerId}`,
                    nextEl: `.slider-offers-next${offerId}`
                }
            })
        })
    }

    if(document.querySelector('.columns__slider')){
        let allSlidersColumns =  document.querySelectorAll('.columns__slider');

        allSlidersColumns.forEach((sliderColumns, index)=>{
            let numberColumns = sliderColumns.dataset.columns;
            let quadColumns = new Swiper('.columns__slider',{
                speed: 700,
                loop: true,
                slidesPerView: 1,
                spaceBetween: 10,
                navigation: {
                    prevEl: '.columns-prev',
                    nextEl: '.columns-next'
                },
                breakpoints: {
                    760: {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                    1025: {
                        slidesPerView: `${numberColumns}`,
                        spaceBetween: 40,
                    }
                }
            });
        })
    }

    let swiperCards = new Swiper('.cards__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            prevEl: `.cards-prev`,
            nextEl: `.cards-next`
        },
        pagination: {
            el: '.cards-pagination',
            clickable: true
        },
        breakpoints: {
            760: {
                slidesPerView: 2
            },
            1025: {
                slidesPerView: 4
            }
        }
    });

    let quadGalleryHotels = new Swiper('.gallery-quad__hotels-slider',{
        speed: 700,
        loop: true,
        slidesPerView: 1.1,
        spaceBetween: 10,
        navigation: {
            prevEl: `.gallery-quad-prev`,
            nextEl: `.gallery-quad-next`
        },
        breakpoints: {
            760: {
                slidesPerView: 1,
                spaceBetween: 0,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                }
            },
            1025: {
                slidesPerView: 1,
                spaceBetween: 0,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                }
            }
        }
    });

    let quadGalleryHotelsAux = new Swiper('.gallery-quad__slider-aux',{
        speed: 700,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });

    quadGalleryHotels.controller.control = quadGalleryHotelsAux;
    quadGalleryHotelsAux.controller.control = quadGalleryHotels;

    let quadSliderHotels = new Swiper('.slider-hotels__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        uniqueNavElements: false,
        pagination: {
            el: '.slider-hotels-pagination',
            clickable: true
        },
        navigation: {
            prevEl: '.slider-hotels-prev',
            nextEl: '.slider-hotels-next'
        }
    });

    let swiperEvents = new Swiper('.events-quad__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 26,
        navigation: {
            prevEl: `.events-quad-prev`,
            nextEl: `.events-quad-next`
        },
        pagination: {
            el: '.events-quad-pagination',
            clickable: true
        },
        breakpoints: {
            760: {
                slidesPerView: 2
            },
            1025: {
                slidesPerView: 3
            }
        }
    });

    let swiperMenus = new Swiper('.menus-quad__slider',{
        loop: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 26,
        navigation: {
            prevEl: `.menus-quad-prev`,
            nextEl: `.menus-quad-next`
        },
        pagination: {
            el: '.menus-quad-pagination',
            clickable: true
        },
        breakpoints: {
            760: {
                slidesPerView: 2
            },
            1025: {
                slidesPerView: 4
            }
        }
    });
});